import { getTranslation } from '@Green-Dot-Corporation/eureka-lib-i18n-utils';

export default class CustomError extends Error {
    constructor(object) {
        super('CustomError');

        const errorObject = {
            title: getTranslation('errorCallout.title'),
            msg: getTranslation('errorCallout.msg'),
            buttonText: getTranslation('errorCallout.buttonText'),
        };

        this.errorObject = { ...errorObject, ...object };
    }
}
